import React from 'react';
import PropTypes from 'prop-types';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Button } from '@rsos/components/capstone/base';
import { FetchErrorContainer, ErrorText } from '../InviteAgencyModal.styles';

/**
 * Fetch error component
 * @param {String} error - Fetch error
 * @param {Function} onHandleFetchRetry - Retry fetch available agencies handler.
 */
const FetchError = ({ error, onHandleFetchRetry }) => {
  const formattedError =
    error && typeof error === 'string'
      ? error
      : 'There was an error fetching agencies';

  return (
    <FetchErrorContainer data-name="fetch-error">
      <Box align="center" color="lightDanger" flow={7} horizontal>
        <AttentionTriangleIcon height={14} width={14} />
        <ErrorText>{formattedError}</ErrorText>
      </Box>
      <Button
        btnType="secondary"
        dataName="retry-button"
        onClick={onHandleFetchRetry}
        size="small"
      >
        Retry
      </Button>
    </FetchErrorContainer>
  );
};

FetchError.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onHandleFetchRetry: PropTypes.func,
};

export default FetchError;
